import { useCallback, useMemo, useSyncExternalStore } from 'react';

type SupportViewport = { top: number; left: number; width: number; height: number };

export function useSupportViewport(active: boolean) {
  const subscribe = useCallback(
    (notify: () => void) => {
      const visual = window.visualViewport;
      if (!active || !visual) return () => {};
      visual.addEventListener('resize', notify);
      visual.addEventListener('scroll', notify);
      return () => {
        visual.removeEventListener('resize', notify);
        visual.removeEventListener('scroll', notify);
      };
    },
    [active]
  );
  // A primitive snapshot stays stable until the browser viewport actually changes.
  const snapshot = useSyncExternalStore(
    subscribe,
    () => {
      const visual = window.visualViewport;
      return active && visual
        ? JSON.stringify({
            top: visual.offsetTop,
            left: visual.offsetLeft,
            width: visual.width,
            height: visual.height,
          })
        : null;
    },
    () => null
  );
  return useMemo(
    () => (snapshot ? (JSON.parse(snapshot) as SupportViewport) : undefined),
    [snapshot]
  );
}
